import React from "react";
import styles from "./scrollable-table.module.scss";
import {TableCell} from "../table/table-cell";
import classNames from "classnames"

export const ScrollableTableCell = ({children, className}) => {
  return (<>
      <TableCell className={classNames(styles.transparent_cell, className)}/>
      <TableCell className={classNames(styles.first_cell, className)}>
        {children}
      </TableCell>
    </>

  )
};